import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api";
import VoxelBackground from "../components/VoxelBackground";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await api.post("/auth/register", { name, email, password });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("parent", JSON.stringify(res.data.parent));
      navigate("/dashboard");
    } catch (err: any) {
      setError(err.response?.data?.error || "Błąd rejestracji");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <VoxelBackground />
      <div style={styles.box}>
        <h1 style={styles.logo}>🧮 Mathix</h1>
        <p style={styles.subtitle}>Stwórz konto dla swojego dziecka!</p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="text"
            placeholder="Twoje imię"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Hasło"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? "Rejestracja..." : "Zarejestruj się 🎉"}
          </button>
        </form>

        <p style={styles.link}>
          Masz już konto?{" "}
          <Link to="/login" style={{ color: "#6c63ff" }}>
            Zaloguj się
          </Link>
        </p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: "100vh",
    background: "#87CEEB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
  },
  box: {
    background: "white",
    borderRadius: "20px",
    padding: "40px",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
    boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
    position: "relative",
    zIndex: 1,
  },
  logo: { fontSize: "48px", margin: "0 0 8px" },
  subtitle: { color: "#888", marginBottom: "32px" },
  input: {
    width: "100%",
    padding: "14px",
    marginBottom: "16px",
    borderRadius: "12px",
    border: "2px solid #eee",
    fontSize: "16px",
    boxSizing: "border-box" as const,
  },
  button: {
    width: "100%",
    padding: "14px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "18px",
    cursor: "pointer",
    marginBottom: "16px",
  },
  error: {
    background: "#fee",
    color: "#c00",
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
  link: { color: "#888" },
};